import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

import { NavigationObserver } from './NavigationObserver';
import { PageViewDeduper } from './PageViewDeduper';

export class PageViewEngine {
  private readonly context: PixelRuntimeContext;

  private readonly deduper: PageViewDeduper;

  private navigationObserver: NavigationObserver | null = null;

  constructor(context: PixelRuntimeContext) {
    this.context = context;
    this.deduper = new PageViewDeduper(
      context.config.modules.core.pageView.dedupeMs
    );
  }

  init(): void {
    const { pageView } = this.context.config.modules.core;

    if (!pageView.enabled) return;

    if (pageView.trackInitialPageView) {
      this.trackPageView();
    }

    if (pageView.spa) {
      this.navigationObserver = new NavigationObserver(() => {
        this.trackPageView();
      });
      this.navigationObserver.start();
    }
  }

  trackPageView(): void {
    const metadata = this.context.services.browserMetadata.getMetadata();
    const path = metadata.path ?? '';
    const timestamp = Date.now();

    if (!this.deduper.shouldDispatch(path, timestamp)) {
      this.context.logger.debug('[PageViewEngine] Page view deduplicated');
      return;
    }

    const commercePayload =
      this.context.services.commerce.resolvePageViewEnrichment();

    const event = this.context.services.eventBuilder.build({
      type: 'PAGE_VIEW' as const,
      ...(commercePayload ?? {}),
    });

    this.context.logger.debug('[PageViewEngine] Dispatching PAGE_VIEW');
    this.context.services.dispatcher.dispatch(event);
  }

  destroy(): void {
    this.navigationObserver?.destroy();
    this.navigationObserver = null;
    this.deduper.reset();
  }
}
